import { cn } from "~/lib/utils";

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Standard page wrapper. The responsive max-width and horizontal gutters are
 * provided globally by <main> in MainLayoutContent, so pages should NOT add
 * their own `max-w-[Xvw]` hacks — just render content here for consistent
 * spacing across the app.
 */
export function PageContainer({ children, className }: PageContainerProps) {
  return (
    <div className={cn("w-full min-w-0 space-y-6", className)}>{children}</div>
  );
}
